import { get, post } from '@/utils/request';

export const companysByProject = (search_info) => {
  return get('/api/v1/companys_by_project', { search_info });
};

export const licenseocr = (id) => {
  return get(`/api/v1/license_ocr/${id}`);
};

export const cert_ocr = (id) => {
  return get(`/api/v1/cert_ocr/${id}`);
};

export const companySave = (params) => {
  return post(`/api/v1/company`, params);
};

export const ggbCompanysava = (params) => {
  return post(`/api/v1/ggb_companysava`, params);
};

export const companyCertificateModify = (params) => {
  return post(`/api/v1/company_certificate_modify`, params);
};
